import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md card-warm rounded-3xl p-8" data-testid="forgot-form">
        <div className="text-center mb-6">
          <Logo className="h-20 mx-auto mb-3" />
          <h1 className="headline text-3xl text-[#f7f3ec]">Forgot Password</h1>
          <p className="text-[#a9a196] text-sm">We'll email you a secure reset link</p>
        </div>
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto text-[#4ade80] mb-3" size={40} />
            <p className="text-[#d6cec2]">If <span className="text-[#f3c649]">{email}</span> is registered, a reset link is on its way. Check your inbox (and spam). The link works for 1 hour.</p>
            <Link to="/login" className="inline-block mt-6 btn-gold rounded-full px-6 py-3 font-display uppercase tracking-wide" data-testid="forgot-back-login">Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="Your account email" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-5 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="forgot-email" />
            <button disabled={loading} className="w-full btn-ember rounded-full py-3.5 font-display uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60" data-testid="forgot-submit">
              {loading ? <Loader2 className="animate-spin" size={18} /> : null} Send Reset Link
            </button>
            <p className="text-center text-sm text-[#a9a196] mt-5">Remembered it? <Link to="/login" className="text-[#f3c649]">Back to login</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
